export * from './accident-participants.model';
